import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import FormShipping from './FormShipping';
import FormPayment from './FormPayment';


export default class RightSideCheckout extends Component{
  constructor(props) {
    super(props);    
    this.state = {
      activeTab: '1',
      dataShipping: '',
      needValidateShipping: false,
      isShippingFulfilled: false
    };

    this.toggle = this.toggle.bind(this);
    this.openPaymentTab = this.openPaymentTab.bind(this);
   
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.isShippingFulfilled && prevState.isShippingFulfilled !== this.state.isShippingFulfilled)
      this.toggle('2');
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      let { activeTab } = this.state;
      switch(tab){
        case '2': {
          if(this.state.isShippingFulfilled) activeTab = tab;
        }
        break;
        default: activeTab = tab; break;
      }
      this.setState({
        activeTab
      });
    }
  }

  toggleShippingFulFilled = (bool) => this.setState({ isShippingFulfilled: bool, needValidateShipping: false })

  // openPaymentTab(payload, shippingFulFilled) {
  // openPaymentTab(payload) {
  async openPaymentTab() {
    // console.log('valid', this.state.isShippingFulfilled)
    // this.toggle('2')
    await this.toggleShippingFulFilled(true);
    this.toggle('2');
    // this.setState({
    //   // dataShipping: payload,
    //   isShippingFulfilled: false,
    //   needValidateShipping: true
    // })
  }

  onTabPaymentClick = () => this.setState({ isShippingFulfilled: false, needValidateShipping: true })
  
  render() {
    return (
      <div className="thumbnail-container" style={{padding: '0'}}>
      <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
            >
              SHIPPING
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={this.onTabPaymentClick}
            >
              PAYMENT
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab} style={{padding: '15px'}}>
          <TabPane tabId="1">
            <FormShipping
              dataAuth={this.props.dataAuth}
              onClickAddress={this.props.onClickAddress}
              clearAddress={this.props.clearAddress}
              handleNextTab={this.openPaymentTab}
              dataPostalCode={this.props.dataPostalCode}
              dataProvinces={this.props.dataProvinces}
              // dataShipping={this.props.dataShipping}

              /* From Old Code */
              _handleSelectCountryChange={this.props._handleSelectCountryChange} 
              _country={this.props._country} 
              _countryList={this.props._countryList}
              _handleSelectProvinceChange={this.props._handleSelectProvinceChange} 
              _province={this.props._province} 
              _provinceList={this.props._provinceList}
              _handleSelectCityChange={this.props._handleSelectCityChange}
              _city={this.props._city} 
              _cityList={this.props._cityList} 
              _handleChange={this.props._handleChange}
              _updateState={this.props._updateState} 
              _error={this.props._error} 
              latestShipping={this.props.latestShipping} 

              _id_shipping={this.props._id_shipping}
              _alias={this.props._alias}
              _fullName={this.props._fullName}
              _phoneNumber={this.props._phoneNumber}
              _alamat={this.props._alamat}
              _notes={this.props._notes}
              _selectedProvince={this.props._selectedProvince}
              _selectedCity={this.props._selectedCity}
              _postalCode={this.props._postalCode}
              onChooseShipping={this.props.onChooseShipping}
              needValidateShipping={this.state.needValidateShipping}
              toggleShippingFulFilled={this.toggleShippingFulFilled}
            />
          </TabPane>
          <TabPane tabId="2">
            <FormPayment
              dataAuth={this.props.dataAuth}
              dataSell={this.props.sell}
              handleClickAddress={this.props.handleClickAddress} 
              dataShipping={this.state.dataShipping}
              
              /* From old code */              
              _getLayananPrice={this.props._getLayananPrice}
              _kickAmount={this.props._kickAmount}
              _paymentType={this.props._paymentType}
              _getTotal={this.props._getTotal}
              _getWalletValue={this.props._getWalletValue}
              _handleChange={this.props._handleChange} 
              _installmentsType={this.props._installmentsType} 
              _handleKickAmount={this.props._handleKickAmount}
              _handlePaymentTypeChange={this.props._handlePaymentTypeChange} 
              _installmentsList={this.props._installmentsList} 
              walletPayment={this.props.walletPayment} 
              _handleWalletPaymentCheckedChange={this.props._handleWalletPaymentCheckedChange} 
              _getTotalWithoutWallet={this.props._getTotalWithoutWallet}               
              _hasError={this.props._hasError} 
              _error={this.props._error} 
              _handleUmbreShippingCheckedChange={this.props._handleUmbreShippingCheckedChange} 
              umbreShipping={this.props.umbreShipping} 
              _voucherInput={this.props._voucherInput} 
              _isValidVoucher={this.props._isValidVoucher} 
              _applyVoucher={this.props._applyVoucher} 
              _handleClearVoucher={this.props._handleClearVoucher} 

              _shippingFee={this.props._shippingFee} 
              _discount={this.props._discount} 
              _productPromo={this.props._productPromo} 

              _submitPayment={this.props._submitPayment}
              // _toa={this.props._toa}
              _renderError={this.props._renderError }
              _onSubmit={this.props._onSubmit} 
              _balanceUser={this.props._balanceUser}
              _askingPrice={this.props._askingPrice}
              _umbreEnabled={this.props._umbreEnabled}
              _handleChangeTerms={this.props._handleChangeTerms}
              _shouldRedirect = {this.props._shouldRedirect}
              _askingPriceStatus={this.props._askingPriceStatus}
            />
          </TabPane>
        </TabContent>
      </div>
    );
  }

}